import { css } from "styled-components";
import token from "styled-token";
import { buttonResetMixin } from "../buttonResetMixin";
import { StyledIcon } from "../../components/Icon/Icon";
export var TagCloseButtonMixin = function TagCloseButtonMixin(props) {
  return token({
    focusShadow: "shadows.focus",
    hoverOpacity: "opacities.opacity300",
    targetPadding: "Tag.targetPadding",
    borderRadius: "radii.ellipse"
  }, function (tokens) {
    return css(["", " padding:", "px;margin:-", "px;&:hover{opacity:", ";}outline:none;&:focus ", "{border-radius:", ";box-shadow:", ";}"], buttonResetMixin(props), tokens.targetPadding, tokens.targetPadding, tokens.hoverOpacity, StyledIcon, tokens.borderRadius, tokens.focusShadow);
  })(props);
};